import {useQuery} from '@apollo/client';
import {Add, Edit} from '@mui/icons-material';
import {
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import {useEffect, useState} from 'react';

import ButtonResponsive from '../../../components/buttons/button-responsive';
import Filtros from '../../../components/filtro/filtros';
import Input from '../../../components/input/input';
import {agendamentoSituacao} from '../../../constants/enum-labels';
import {FIND_ALL_AGENDAMENTOS} from '../../../graphql/queries';
import Data from '../../../utils/data';
import AgendamentoModal from './agendamento-modal';

export default function ConsultaAgendamentos() {
  const [agendamentos, setAgendamentos] = useState([]);
  const [searchDTO, setSearchDTO] = useState({});
  const [page, setPage] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [selecionado, setSelecionado] = useState(undefined);

  const agendamentosQuery = useQuery(FIND_ALL_AGENDAMENTOS, {
    variables: {
      pageable: {
        pageNumber: page,
        pageSize: 20,
        sortField: 'dataCriacao',
        sortDir: 'DESC',
      },
      searchDTO: {
        search: searchDTO.search || undefined,
      },
    },
  });

  useEffect(() => {
    if (agendamentosQuery.loading) return;

    setAgendamentos(agendamentosQuery.data?.agendamentos?.content || []);
    setTotalElements(agendamentosQuery.data?.agendamentos?.totalElements || 0);
  }, [agendamentosQuery]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (!selecionado) return;

    setOpenModal(true);
  }, [selecionado]);

  useEffect(() => {
    setPage(0);
  }, [searchDTO]);

  return (
    <Grid container item xs={12} paddingBottom={4}>
      <Filtros>
        <Grid item xs>
          <Input
            name="busca"
            placeholder="Pesquisar por nome"
            type="text"
            autoComplete="off"
            value={searchDTO.search}
            onChange={({target}) =>
              setSearchDTO((f) => ({...f, search: target?.value}))
            }
          />
        </Grid>
      </Filtros>
      <Grid
        container
        item
        xs={12}
        paddingBottom={1}
        alignItems={'center'}
        justifyContent={'flex-end'}>
        <Button id="text" endIcon={<Add />} onClick={() => setOpenModal(true)}>
          Cadastrar novo
        </Button>
      </Grid>
      <TableContainer id="table-container">
        <Table id="table">
          <TableHead id="table-head">
            <TableRow>
              <TableCell>Atleta</TableCell>
              <TableCell>Data solicitação</TableCell>
              <TableCell>Profissionais</TableCell>
              <TableCell>Agendamento</TableCell>
              <TableCell>Situação</TableCell>
              <TableCell sx={{width: '182px'}} align="center">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody id="table-body">
            {agendamentos.map((a) => (
              <TableRow key={a.id} id="table-row">
                <TableCell>{a.atleta?.nome}</TableCell>
                <TableCell>{Data.dataFormat(a.dataCriacao)}</TableCell>
                <TableCell>{a.profissionais?.length}</TableCell>
                <TableCell>{`${Data.dataFormat(a.data)} ${
                  a.hora || ''
                }`}</TableCell>
                <TableCell>{agendamentoSituacao[a.situacao]}</TableCell>
                <TableCell
                  align="right"
                  sx={{display: 'flex', flexDirection: 'row'}}>
                  <ButtonResponsive
                    id="primary"
                    value="Editar"
                    onClick={() => setSelecionado(a)}
                    icon={<Edit />}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow id="table-row-footer">
              <TableCell id="table-pagination" colSpan={6}>
                <TablePagination
                  component="div"
                  count={totalElements}
                  rowsPerPageOptions={[]}
                  rowsPerPage={20}
                  page={page}
                  labelDisplayedRows={({from, to, count}) =>
                    `${from}-${to} de ${count}`
                  }
                  onPageChange={handleChangePage}
                />
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
      <AgendamentoModal
        open={openModal}
        agendamento={selecionado}
        onClose={() => {
          setOpenModal(false);
          setSelecionado(undefined);
          agendamentosQuery.refetch();
        }}
      />
    </Grid>
  );
}
